//react
import { useEffect, useState } from 'react';
import { BeatLoader } from 'react-spinners';

//css
import './accountMngt.css';

//kendo
import { Button } from '@progress/kendo-react-buttons';
import kendo from '@progress/kendo-ui';
import { Input } from '@progress/kendo-react-inputs';
import { Checkbox } from '@progress/kendo-react-inputs';

//service
import { getUser } from '../../../service/authService';
import { getAccountInfo, setUpdateAccountInfo } from '../../../service/mngt/accoutMngtService';

//json
import accountInfoDummy from './accountInfoDummy.json';

//component
import TimePickerKo from '../../com/dateInputs/timePickerKo';

const AccountMngt = ({ conn }) => {
  const [loading, setLoading] = useState(false);
  const userInfo = getUser();
  const [accountInfo, setAccountInfo] = useState(accountInfoDummy);
  const [checkBoxInfo, setCheckBoxInfo] = useState({
    general: [0, 0, 0, 0, 0, 0, 0],
    manage: [0, 0, 0, 0, 0, 0, 0],
    danger: [0, 0, 0, 0, 0, 0, 0],
  });
  const [timeValue, setTimeValue] = useState({
    generalStartTime: new Date(),
    generalEndTime: new Date(),
    manageStartTime: new Date(),
    manageEndTime: new Date(),
    dangerStartTime: new Date(),
    dangerEndTime: new Date(),
  });
  const [infoVisible, setInfoVisible] = useState({
    dailyInfo: false,
    dangerChngInfo: false,
    generalElder: false,
    manageElder: false,
    dangerElder: false,
  });

  const pwdInputChngEvt = e => {
    const { target, value } = e;
    if (target.element.name === 'userPassword') {
      setAccountInfo({ ...accountInfo, userPassword: value });
    } else if (target.element.name === 'userPasswordCheck') {
      setAccountInfo({ ...accountInfo, userPasswordCheck: value });
    }
  };

  const phoneChngEvt = e => {
    const { value } = e;
    setAccountInfo({ ...accountInfo, protectorPhone: value });
  };

  const telePhoneChngEvt = e => {
    const { value } = e;
    setAccountInfo({ ...accountInfo, userPhone: value });
  };

  // 유저 정보 저장
  const submitBtnClickEvt = () => {
    // 여기서 Validaion 처리
    // 1-1 PASSWORD 확인 및 이전 PASSWORD 처리 있는가?
    if (accountInfo.userPassword !== '') {
      if (accountInfo.userPassword !== accountInfo.userPasswordCheck) {
        kendo.alert('입력하신 변경된 비밀번호와 확인 비밀번호와 맞지 않습니다. 다시 확인하시고 똑같이 입력 해주세요.');
        return;
      } else {
        // 비밀번호 정규식 (영어 대문자, 소문자 포함 숫자 포함 특수문자 포함 8자리 이상)
        const regPassword = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,15}$/;
        // const regPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*+=-]).{9,15}$/;
        if (!regPassword.test(accountInfo.userPassword)) {
          kendo.alert('유효하지 않은 비밀번호입니다! 영어 ,숫자,특수문자 포함한 8자리 이상 15자 미만으로 작성해주세요.');
          return;
        }
      }
    }
    // 3-1 휴대폰 번호 처리
    const regPhone = /[01](0|1|6|7|8|9)-(\d{4}|\d{3})-\d{4}$/;
    if (accountInfo.protectorPhone && !regPhone.test(accountInfo.protectorPhone)) {
      kendo.alert('유효하지 않은 개인 연락처 번호입니다!');
      return;
    }

    const regTelePhone = new RegExp(/^\d{3}-\d{3,4}-\d{4}$/);
    if (accountInfo.userPhone && !regTelePhone.test(accountInfo.userPhone)) {
      kendo.alert('유효하지 않은 사무실 연락처 번호입니다!');
      return;
    }
    // 3-2.휴대폰 알람은 Y 인데 휴대폰 입력 값이 없다면
    if (!accountInfo.protectorPhone && accountInfo.alarmSet.kakaoYn === 'Y') {
      kendo.alert('개인 연락처를 입력하지 않으면 알림톡(카카오)을 수신할 수 없습니다!');
      return;
    }

    // 4. 이메일 수신시간 0 ~ 23시 사이 작성 하였는가?

    kendo.confirm('저장하시겠습니까?').then(
      () => {
        setUpdateAccountInfo(conn, accountInfo)
          .then(response => {
            kendo.alert('저장 완료');
            window.location.replace('/mngt/account');
          })
          .catch(error => console.log('setUpdateAccountInfo Error', error));
      },
      () => {
        kendo.alert('취소되었습니다.');
        return;
      },
    );
  };

  //대상자별 알림 수신 시간 변경이벤트
  const timeChngEvt = e => {
    const { target, value } = e;
    const resultHour = value.getHours() < 10 ? '0' + value.getHours() : value.getHours() + '';
    const resultMinute = value.getMinutes() < 10 ? '0' + value.getMinutes() : value.getMinutes() + '';
    const result = resultHour + resultMinute;

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const hour = value.getHours();
    const minute = value.getMinutes();
    if (target.name === 'generalStartTime') {
      setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, generalStartTime: result } });
      setTimeValue({ ...timeValue, generalStartTime: new Date(year, month, day, hour, minute) });
    } else if (target.name === 'generalEndTime') {
      setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, generalEndTime: result } });
      setTimeValue({ ...timeValue, generalEndTime: new Date(year, month, day, hour, minute) });
    } else if (target.name === 'manageStartTime') {
      setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, manageStartTime: result } });
      setTimeValue({ ...timeValue, manageStartTime: new Date(year, month, day, hour, minute) });
    } else if (target.name === 'manageEndTime') {
      setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, manageEndTime: result } });
      setTimeValue({ ...timeValue, manageEndTime: new Date(year, month, day, hour, minute) });
    } else if (target.name === 'dangerStartTime') {
      setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, dangerStartTime: result } });
      setTimeValue({ ...timeValue, dangerStartTime: new Date(year, month, day, hour, minute) });
    } else if (target.name === 'dangerEndTime') {
      setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, dangerEndTime: result } });
      setTimeValue({ ...timeValue, dangerEndTime: new Date(year, month, day, hour, minute) });
    }
  };

  /* 일반 대상자 체크박스 이벤트 */
  const generalWeekCheckEvt = e => {
    const name = parseInt(e.target.element.name);
    let generalTemp = checkBoxInfo.general.slice();

    if (generalTemp[name] === 0) generalTemp[name] = 1;
    else generalTemp[name] = 0;

    let result = '';
    for (let i = 0; i < 7; i++) {
      result += generalTemp[i];
    }
    setCheckBoxInfo({ ...checkBoxInfo, general: generalTemp });
    setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, generalWkdd: result } });
  };
  /* 관리 대상자 체크박스 이벤트 */
  const manageWeekCheckEvt = e => {
    const name = parseInt(e.target.element.name);
    let manageTemp = checkBoxInfo.manage.slice();

    if (manageTemp[name] === 0) manageTemp[name] = 1;
    else manageTemp[name] = 0;

    let result = '';
    for (let i = 0; i < 7; i++) {
      result += manageTemp[i];
    }
    setCheckBoxInfo({ ...checkBoxInfo, manage: manageTemp });
    setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, manageWkdd: result } });
  };
  /* 위험 대상자 체크박스 이벤트 */
  const dangerWeekCheckEvt = e => {
    const name = parseInt(e.target.element.name);
    let dangerTemp = checkBoxInfo.danger.slice();

    if (dangerTemp[name] === 0) dangerTemp[name] = 1;
    else dangerTemp[name] = 0;

    let result = '';
    for (let i = 0; i < 7; i++) {
      result += dangerTemp[i];
    }
    setCheckBoxInfo({ ...checkBoxInfo, danger: dangerTemp });
    setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, dangerWkdd: result } });
  };

  //대상자별 일~토 체크박스 초기화
  const weekCheckBoxInit = response => {
    let generalTemp = [];
    let manageTemp = [];
    let dangerTemp = [];
    for (let i = 0; i < 7; i++) {
      generalTemp.push(parseInt(response.alarmSet.generalWkdd.substring(i, i + 1)));
      manageTemp.push(parseInt(response.alarmSet.manageWkdd.substring(i, i + 1)));
      dangerTemp.push(parseInt(response.alarmSet.dangerWkdd.substring(i, i + 1)));
    }
    setCheckBoxInfo({ ...checkBoxInfo, general: generalTemp, manage: manageTemp, danger: dangerTemp });
  };

  //대상자별 타임피커 초기화
  const weekTimePickerValueInit = response => {
    const v = response.alarmSet;
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const day = today.getDate();
    const _generalStartTime = new Date(year, month, day, v.generalStartTime.substring(0, 2), v.generalStartTime.substring(2, 4));
    const _generalEndTime = new Date(year, month, day, v.generalEndTime.substring(0, 2), v.generalEndTime.substring(2, 4));
    const _manageStartTime = new Date(year, month, day, v.manageStartTime.substring(0, 2), v.manageStartTime.substring(2, 4));
    const _manageEndTime = new Date(year, month, day, v.manageEndTime.substring(0, 2), v.manageEndTime.substring(2, 4));
    const _dangerStartTime = new Date(year, month, day, v.dangerStartTime.substring(0, 2), v.dangerStartTime.substring(2, 4));
    const _dangerEndTime = new Date(year, month, day, v.dangerEndTime.substring(0, 2), v.dangerEndTime.substring(2, 4));

    const result = {
      generalStartTime: _generalStartTime,
      generalEndTime: _generalEndTime,
      manageStartTime: _manageStartTime,
      manageEndTime: _manageEndTime,
      dangerStartTime: _dangerStartTime,
      dangerEndTime: _dangerEndTime,
    };

    setTimeValue(result);
  };

  const YnChngEvt = e => {
    const { target, value } = e;
    let result = '';
    if (value === false) result = 'N';
    else result = 'Y';

    if (target.element.name === 'kakaoYn') {
      setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, kakaoYn: result } });
    } else if (target.element.name === 'dailyStatusYn') {
      setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, dailyStatusYn: result } });
    } else if (target.element.name === 'dangerYn') {
      setAccountInfo({ ...accountInfo, alarmSet: { ...accountInfo.alarmSet, dangerYn: result } });
    }
  };

  useEffect(() => {
    setLoading(true);
    const search = {
      userId: userInfo.userId,
    };
    getAccountInfo(conn, search)
      .then(response => {
        //초기화는 response로 처음에 한번만 함
        weekCheckBoxInit(response);
        weekTimePickerValueInit(response);
        response.userPassword = '';
        setAccountInfo(response);
        setLoading(false);
      })
      .catch(error => console.log('getAccountInfo Error!', error));
  }, []);

  return (
    <div
      className="accountMngtContents"
      style={
        loading
          ? {
              opacity: 0.6,
              pointerEvents: 'none',
              position: 'relative',
            }
          : null
      }>
      <span className="accountMngtFirstContent">
        <div className="accountMngtElderDiv">
          <div> · 비밀번호 변경(변경시 입력)</div>
          <div>
            <Input placeholder="8자 이상 15자 이하 영문, 숫자, 특수문자 조합" type="password" name="userPassword" onChange={pwdInputChngEvt}></Input>
          </div>
          <div>
            <Input placeholder="비밀번호 확인" type="password" name="userPasswordCheck" onChange={pwdInputChngEvt}></Input>
          </div>
          <br></br>
          <br></br>
          <div>· 사무실 연락처</div>
          <div>
            <Input placeholder="041-123-4567" value={accountInfo.userPhone} onChange={telePhoneChngEvt}></Input>
          </div>
          <div>· 개인 연락처</div>
          <div>
            <Input placeholder="010-0000-0000" value={accountInfo.protectorPhone} onChange={phoneChngEvt}></Input>
          </div>
        </div>
      </span>
      <span className="accountMngtSecondContent">
        <div className="accountMngtElderDiv">
          · 알림 수신여부
          <div>
            <Checkbox label="알림톡(카카오)" checked={accountInfo.alarmSet.kakaoYn === 'Y'} name="kakaoYn" onChange={YnChngEvt} />
          </div>
          <div>
            <b>※ 일일 현황 알림 &nbsp;&nbsp;</b>
            <Checkbox label="" checked={accountInfo.alarmSet.dailyStatusYn === 'Y'} name="dailyStatusYn" onChange={YnChngEvt} />
            <img
              src="/images/info.png"
              alt="정보"
              className="infoImg"
              onMouseOver={() => {
                setInfoVisible({ ...infoVisible, dailyInfo: true });
              }}
              onMouseOut={() => {
                setInfoVisible({ ...infoVisible, dailyInfo: false });
              }}></img>
            {infoVisible.dailyInfo && <span className="infoSpan">* 일일현황알림 : 평일 오전9시 전일 대상자현황 알림전송</span>}
          </div>
          <div>
            <b>※ 위험전환 시 알림&nbsp;&nbsp;</b>
            <Checkbox label="" checked={accountInfo.alarmSet.dangerYn === 'Y'} name="dangerYn" onChange={YnChngEvt} />
            <img
              src="/images/info.png"
              alt="정보"
              className="infoImg"
              onMouseOver={() => {
                setInfoVisible({ ...infoVisible, dangerChngInfo: true });
              }}
              onMouseOut={() => {
                setInfoVisible({ ...infoVisible, dangerChngInfo: false });
              }}></img>
            {infoVisible.dangerChngInfo && <span className="infoSpan">* 위험전환 시 알림 : 위험이벤트 발생 시 알림 전송</span>}
          </div>
        </div>
        <div className="accountMngtElderDiv">
          · 일반 대상자
          <img
            src="/images/info.png"
            alt="정보"
            className="infoImg"
            onMouseOver={() => {
              setInfoVisible({ ...infoVisible, generalElder: true });
            }}
            onMouseOut={() => {
              setInfoVisible({ ...infoVisible, generalElder: false });
            }}></img>
          {infoVisible.generalElder && <span className="infoSpan">* 일반 대상자 : 관리 대상자, 위험 대상자 미포함 개소</span>}
          <div>
            &nbsp;&nbsp;
            <Checkbox label="일요일" name="0" onChange={generalWeekCheckEvt} checked={checkBoxInfo.general[0]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="월요일" name="1" onChange={generalWeekCheckEvt} checked={checkBoxInfo.general[1]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="화요일" name="2" onChange={generalWeekCheckEvt} checked={checkBoxInfo.general[2]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="수요일" name="3" onChange={generalWeekCheckEvt} checked={checkBoxInfo.general[3]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="목요일" name="4" onChange={generalWeekCheckEvt} checked={checkBoxInfo.general[4]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="금요일" name="5" onChange={generalWeekCheckEvt} checked={checkBoxInfo.general[5]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="토요일" name="6" onChange={generalWeekCheckEvt} checked={checkBoxInfo.general[6]} />
          </div>
          <div>
            <TimePickerKo
              name="generalStartTime"
              value={timeValue.generalStartTime}
              onChange={timeChngEvt}
              max={timeValue.generalEndTime}></TimePickerKo>
            &nbsp;~&nbsp;
            <TimePickerKo
              name="generalEndTime"
              value={timeValue.generalEndTime}
              onChange={timeChngEvt}
              min={timeValue.generalStartTime}></TimePickerKo>
          </div>
        </div>
        <div className="accountMngtElderDiv">
          · 관리 대상자
          <img
            src="/images/info.png"
            alt="정보"
            className="infoImg"
            onMouseOver={() => {
              setInfoVisible({ ...infoVisible, manageElder: true });
            }}
            onMouseOut={() => {
              setInfoVisible({ ...infoVisible, manageElder: false });
            }}></img>
          {infoVisible.manageElder && <span className="infoSpan">* 관리 대상자 : 담당자가 설정한 관리 필요 개소</span>}
          <div>
            &nbsp;&nbsp;
            <Checkbox label="일요일" name="0" onChange={manageWeekCheckEvt} checked={checkBoxInfo.manage[0]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="월요일" name="1" onChange={manageWeekCheckEvt} checked={checkBoxInfo.manage[1]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="화요일" name="2" onChange={manageWeekCheckEvt} checked={checkBoxInfo.manage[2]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="수요일" name="3" onChange={manageWeekCheckEvt} checked={checkBoxInfo.manage[3]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="목요일" name="4" onChange={manageWeekCheckEvt} checked={checkBoxInfo.manage[4]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="금요일" name="5" onChange={manageWeekCheckEvt} checked={checkBoxInfo.manage[5]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="토요일" name="6" onChange={manageWeekCheckEvt} checked={checkBoxInfo.manage[6]} />
          </div>
          <div>
            <TimePickerKo
              name="manageStartTime"
              value={timeValue.manageStartTime}
              onChange={timeChngEvt}
              max={timeValue.manageEndTime}></TimePickerKo>
            &nbsp;~&nbsp;
            <TimePickerKo name="manageEndTime" value={timeValue.manageEndTime} onChange={timeChngEvt} min={timeValue.manageStartTime}></TimePickerKo>
          </div>
        </div>
        <div className="accountMngtElderDiv">
          · 위험 대상자
          <img
            src="/images/info.png"
            alt="정보"
            className="infoImg"
            onMouseOver={() => {
              setInfoVisible({ ...infoVisible, dangerElder: true });
            }}
            onMouseOut={() => {
              setInfoVisible({ ...infoVisible, dangerElder: false });
            }}></img>
          {infoVisible.dangerElder && <span className="infoSpan">* 위험 대상자 : 당일 이전 일주일 내 위험 2회 이상 발생 개소</span>}
          <div>
            &nbsp;&nbsp;
            <Checkbox label="일요일" name="0" onChange={dangerWeekCheckEvt} checked={checkBoxInfo.danger[0]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="월요일" name="1" onChange={dangerWeekCheckEvt} checked={checkBoxInfo.danger[1]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="화요일" name="2" onChange={dangerWeekCheckEvt} checked={checkBoxInfo.danger[2]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="수요일" name="3" onChange={dangerWeekCheckEvt} checked={checkBoxInfo.danger[3]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="목요일" name="4" onChange={dangerWeekCheckEvt} checked={checkBoxInfo.danger[4]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="금요일" name="5" onChange={dangerWeekCheckEvt} checked={checkBoxInfo.danger[5]} />
            &nbsp;&nbsp; &nbsp;&nbsp;
            <Checkbox label="토요일" name="6" onChange={dangerWeekCheckEvt} checked={checkBoxInfo.danger[6]} />
          </div>
          <div>
            <TimePickerKo
              name="dangerStartTime"
              value={timeValue.dangerStartTime}
              onChange={timeChngEvt}
              max={timeValue.dangerEndTime}></TimePickerKo>
            &nbsp;~&nbsp;
            <TimePickerKo name="dangerEndTime" value={timeValue.dangerEndTime} onChange={timeChngEvt} min={timeValue.dangerStartTime}></TimePickerKo>
          </div>
        </div>
        <div className="accountMngtSaveBtnDiv">
          <Button icon="save" className="accountMngtSaveBtn" onClick={submitBtnClickEvt}>
            저장
          </Button>
        </div>
      </span>

      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={24} color="#1e88e5" />
        </p>
      )}
    </div>
  );
};
export default AccountMngt;
